import { CoinPackageNameEnum, PaymentPlatformEnum } from '@/enums';

/**
 * Payment record type matching the API response structure.
 * This type represents a single payment transaction.
 */
export type Payment = {
    _id: string;
    userId?: string;
    currency: string;
    price: number;
    priceInEur: number;
    provider: PaymentPlatformEnum;
    transactionId: string;
    packageName: CoinPackageNameEnum;
    iapTransactionId?: string;
    createdAt: string;
};

/**
 * Sort configuration for payments table
 * Only these columns support server-side sorting: createdAt, priceInEur, packageName, provider
 */
export type SortConfig = {
    key: 'createdAt' | 'priceInEur' | 'packageName' | 'provider';
    direction: 'asc' | 'desc';
};

/**
 * Pagination state for payments
 */
export type PaginationState = {
    page: number;
    pageSize: number;
    totalItems: number;
    pageCount: number;
};

// Constants
export const PAYMENTS_PAGE_SIZE = 5;
export const PAYMENTS_PAGE_SIZE_OPTIONS = [5, 10, 20, 50];
